export default __webpack_public_path__ + "static/media/googlelogo.48c71b51.png";